import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

import VCreator from "@/shared/views/vCreator.vue";
import cCreatorStep from "@/shared/components/creator/cCreatorStep.vue";
import cCreatorThemes from "@/shared/components/creator/cCreatorThemes.vue";
import cCreatorProduct from "@/shared/components/creator/cCreatorProduct.vue";
import { ButtonPrimarySm } from "@easy/ui/buttons";
import { CardSquare, CardsSquare } from "@easy/ui/cards";
import { RocketIcon } from "@easy/ui/icons";
import { storeToRefs } from "pinia";
import { usePageCreatorStore } from "@/apps/page/project/onboarding/page-creator.store";
import { useI18n } from "vue-i18n";
import { pageOnboardingService } from "@/apps/page/project/onboarding/page-onboarding.service";
import { useOnboardingVideo } from "@/shared/projects/onboarding/useOnboardingVideos";
import { useState } from "@/store/vuex-composition-mappers";
import { onUnmounted } from "vue";

// @ts-expect-error

import { makeLogger } from "@/shared/consola";

const logger = makeLogger("PageCreator.vue");

export default /*@__PURE__*/_defineComponent({
  __name: 'PageCreator',
  setup(__props) {

const { page } = useState("page", ["page"]);
const { locale } = useI18n();
const { video } = useOnboardingVideo("page");
const pageCreatorStore = usePageCreatorStore();
const { onboardState, templates, previewCssVars, previewComponent } = storeToRefs(pageCreatorStore);
const { updateProductInfo, toggleCreatorShown, onboardingAction, sseSubscriber } = pageCreatorStore;

const generateOnboarding = onboardingAction(() => {
    logger.debug("send PAGE onboarding...", locale.value, onboardState.value);
    return pageOnboardingService.sendOnboardData({
        ...onboardState.value,
        pageTemplate: onboardState.value.template,
        pageId: page.value.id,
        pageUuid: page.value.uuid,
        lang: locale.value,
    });
});

const eventSource = pageOnboardingService.listenEventsFor(page.value.uuid, sseSubscriber);
onUnmounted(() => {
    eventSource.close();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(VCreator, {
    canSkipGenerator: !_unref(onboardState).isLoading,
    description: _ctx.$t('page.creator.subtitle'),
    title: _ctx.$t('page.creator.title'),
    video: _unref(video),
    onClose: _cache[4] || (_cache[4] = ($event: any) => (_unref(toggleCreatorShown)(false)))
  }, {
    preview: _withCtx(() => [
      _createElementVNode("div", {
        style: _normalizeStyle({ ..._unref(previewCssVars) })
      }, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(previewComponent))))
      ], 4)
    ]),
    default: _withCtx(() => [
      _createVNode(cCreatorStep, {
        title: _ctx.$t('shared.creator.step_data_source_title'),
        description: _ctx.$t('shared.creator.step_data_source_description'),
        step: 1
      }, {
        default: _withCtx(() => [
          _createVNode(cCreatorProduct, {
            error: _unref(onboardState).error,
            hidePrompt: _unref(onboardState).hidePrompt,
            productSelectLater: _unref(onboardState).productSelectLater,
            "onUpdate:productSelectLater": _cache[0] || (_cache[0] = ($event: any) => ((_unref(onboardState).productSelectLater) = $event)),
            onProductInfoUpdated: _cache[1] || (_cache[1] = ($event: any) => (_unref(updateProductInfo)($event)))
          }, {
            templated: _withCtx(() => [
              _createVNode(_unref(CardsSquare), null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(templates), (template) => {
                    return (_openBlock(), _createBlock(_unref(CardSquare), {
                      key: template.id,
                      title: template.value,
                      "is-selected": template.id === _unref(onboardState).template,
                      onClick: ($event: any) => {
                                _unref(onboardState).template = template.id;
                                _unref(onboardState).promptDescription = `use:(${_unref(onboardState).template})`;
                            }
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createBlock(_resolveDynamicComponent(template.icon), { class: "w-6 h-6" }))
                      ]),
                      _: 2
                    }, 1032, ["title", "is-selected", "onClick"]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["error", "hidePrompt", "productSelectLater"])
        ]),
        _: 1
      }, 8, ["title", "description"]),
      _createVNode(cCreatorStep, {
        title: _ctx.$t('page.creator.step_2_title'),
        description: _ctx.$t('page.creator.step_2_description'),
        step: 2
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(CardsSquare), null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(templates), (template) => {
                return (_openBlock(), _createBlock(_unref(CardSquare), {
                  key: template.id,
                  title: template.value,
                  "is-selected": template.id === _unref(onboardState).template,
                  onClick: ($event: any) => {
                        _unref(onboardState).template = template.id;
                        _unref(onboardState).promptDescription = `use:(${_unref(onboardState).template})`;
                    }
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(template.icon), { class: "w-6 h-6" }))
                  ]),
                  _: 2
                }, 1032, ["title", "is-selected", "onClick"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["title", "description"]),
      _createVNode(cCreatorStep, {
        title: _ctx.$t('page.creator.step_3_title'),
        description: _ctx.$t('page.creator.step_3_description'),
        step: 2
      }, {
        default: _withCtx(() => [
          _createVNode(cCreatorThemes, {
            modelValue: _unref(onboardState).theme,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(onboardState).theme) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["title", "description"]),
      _createVNode(cCreatorStep, {
        title: _ctx.$t('page.creator.step_4_title'),
        description: _ctx.$t('page.creator.step_4_description'),
        step: 3,
        last: true
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(ButtonPrimarySm), {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(generateOnboarding)())),
            loading: _unref(onboardState).isLoading
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(RocketIcon)),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("page.creator.step_4_cta")), 1)
            ]),
            _: 1
          }, 8, ["loading"])
        ]),
        _: 1
      }, 8, ["title", "description"])
    ]),
    _: 1
  }, 8, ["canSkipGenerator", "description", "title", "video"]))
}
}

})